import styled from "styled-components";
import { ICard } from "./Card.interface";

const StyledCard = styled.div<ICard>`
  display: ${({ inline }) => (inline ? "inline-" : "")}flex;
  flex-flow: column;
  text-decoration: none;
  border-radius: 10px;
  overflow: hidden;
  background-color: ${(props) => props.theme.palette.mainBackground};
  border: 1px solid ${(props) => props.theme.palette.neutral4};
  width: ${(props) => (props.width ? `${props.width}px` : "auto")};
  height: max-content;
`;

export default StyledCard;
